export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
export const UPDATE_INSTAGRAM_CONNECTION_STATUS = 'UPDATE_INSTAGRAM_CONNECTION_STATUS';
export const SET_LABELS = 'SET_LABELS';
export const TOGGLE_LOADING_LABELS = 'TOGGLE_LOADING_LABELS';
export const TOGGLE_LOADING_LIBRARIES = 'TOGGLE_LOADING_LIBRARIES';
export const SET_LIBRARIES = 'SET_LIBRARIES';
